import { useEffect, useState } from "react";
import { useLocation } from "react-router";

type Banner = {
  link: string;
  img: string;
  shadow: string;
};
const BANNERS: Banner[] = [
  // {
  //   link: "https://keltir.com/news/52?utm_source=extsite&utm_medium=post&utm_campaign=golem&utm_content=l2hub&utm_term=site",
  //   img: "/s/banners/keltir.gif",
  //   shadow: "#2a1913",
  // },
  // {
  //   link: "https://thebattle.click/?utm_source=hub&utm_medium=wiki",
  //   img: "/s/banners/thebattle.png",
  //   shadow: "#280b42",
  // },
];

export function BannerBlock() {
  const loc = useLocation();
  const [banner, setBanner] = useState<null | Banner>(null);

  useEffect(() => {
    const banner = Math.random() < 0.5 ? BANNERS[0] : BANNERS[1];
    setBanner(banner);
  }, [loc.pathname]);

  return (
    <div
      className="container"
      style={{ display: "flex", justifyContent: "center", paddingBottom: 10 }}
    >
      <a
        href={banner?.link}
        target="_blank"
        style={{ opacity: banner ? 1 : 0 }}
      >
        <img
          className="banner"
          style={{ boxShadow: `${banner?.shadow} 0px 0px 7px 0px` }}
          src={banner?.img}
        />
      </a>
    </div>
  );
}
